import { Schema as Schema$1, DeprecatedDefaultSchema } from "./_chunks-es/Rule.js";
import { DEFAULT_ANNOTATIONS, DEFAULT_DECORATORS, Rule } from "./_chunks-es/Rule.js";
const Schema = Schema$1;
export {
  DEFAULT_ANNOTATIONS,
  DEFAULT_DECORATORS,
  Rule,
  Schema,
  DeprecatedDefaultSchema as default
};
//# sourceMappingURL=index.js.map
